import { _UserData, UserData, UserDataBaseEnum } from "../../infra/storage/localStorage";
import { AuthenticationProps } from "../../view/authentication/authentication"

//import { useNavigate } from "react-router-dom";
export default class AuthenticationContainer {
  public props: AuthenticationProps;
  public searchParams: URLSearchParams
  public userData: UserData
  //public navigate = useNavigate();

  constructor(props: AuthenticationProps, searchParams: URLSearchParams) {
    this.searchParams = searchParams;
    this.userData = _UserData

    this.props = props
  }

  async LoginByToken(callBackOnFailure?: () => void, reportError: boolean = true) {
    let token = this.searchParams.get("token");

    if (token == null) {
      token = this.userData.Get(UserDataBaseEnum.Token)
    }

    this.props.LoginByToken(token, reportError)

    if (token == undefined || token == null) {
      if (callBackOnFailure) callBackOnFailure()
    }
  }
}
